import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AvailablePhoneNumber } from 'src/actions/availableNumbers/availableNumbersResource';

import smsConfigurationResource from 'src/actions/channels/smsConfigurationResource';
import CompanyPhoneNumber from 'src/models/CompanyPhoneNumber/CompanyPhoneNumber';
import { STATUS_SUCCEEDED, useResourceValues } from 'src/presentation/hooks/useResource';

export default function useActivateNumberForSms({ add, isActive, nextStep, saveStep }) {
  const dispatch = useDispatch();
  const { persistingState } = useResourceValues(smsConfigurationResource);
  const [requestSent, setRequestSent] = useState(false);

  const activateNumber = (phone: AvailablePhoneNumber | CompanyPhoneNumber) => {
    setRequestSent(true);
    dispatch(
      add({ number: phone.phoneNumber }, undefined, {
        disableWindowBack: true,
        withoutToast: true,
      })
    );
  };

  const isPersisting = 'persisting' === persistingState;

  useEffect(() => {
    if (requestSent && persistingState === STATUS_SUCCEEDED && isActive) {
      setRequestSent(false);
      saveStep({});
      nextStep();
    }
  }, [isActive, persistingState, nextStep, saveStep, requestSent, setRequestSent]);

  return { activateNumber, isPersisting };
}
